import moment from 'moment'

const initialState = {
  sourceDataSaving: false,
  sourceDataSavingError: false,
  activeEditor: false,
  editorMode: '',
  recalculateCells: false,
  lastChangeTime: null
}

const actionTypes = {
  SourceDataSaving: 'sourceDataSaving',
  SourceDataSaved: 'sourceDataSaved',
  SourceDataSavingError: 'SourceDataSavingError',
  ChangeEditorMode: 'changeEditorMode',
  StopRecalculation: 'stopRecalculation'
}

function reducer (state = { ...initialState }, action) {
  switch (action.type) {
    case actionTypes.SourceDataSaving: return { ...state, sourceDataSaving: true }
    case actionTypes.SourceDataSaved: return { ...state,
      sourceDataSaving: false,
      lastChangeTime: moment(),
      recalculateCells: true
    }
    case actionTypes.SourceDataSavingError: return { ...state, sourceDataSaving: false, sourceDataSavingError: true
    }
    case actionTypes.ChangeEditorMode: return { ...state,
      activeEditor: action.data.isEditorOpen,
      editorMode: action.data.editorMode
    }
    case actionTypes.StopRecalculation: return { ...state, recalculateCells: false }
    default: return state
  }
}

export { reducer, actionTypes, initialState }



// WEBPACK FOOTER //
// ./src/components/report-tables/editable/reducer.js